import { Email, FolderId } from "./types"

export const FOLDER_LABELS: Record<FolderId, string> = {
	inbox: "Inbox",
	spam: "Spam",
	sent: "Sent",
	trash: "Trash",
}

export const EMAILS_BY_FOLDER: Record<FolderId, Email[]> = {
	inbox: [
		{
			id: "in-1",
			from: "godintrash@proton.me",
			to: "you@trashmail.biz",
			subject: "Trash Godz E-Zine 002",
			date: "08/04/2026 2:28 PM",
			htmlSrc: "/ezine/the-filth-review-02.html",
		},
		{
			id: "in-2",
			from: "Webmaster <webmaster@trashovision.biz>",
			to: "you@trashmail.biz",
			subject: "Welcome to TRASHMAIL!!!",
			date: "08/01/2026 9:14 AM",
			body: [
				"Thank you for signing up for a FREE TRASHMAIL account!",
				"You now have 2 slops of storage, which is more than the last fella",
				"Remember: never give your password to anyone, including us, unless we ask really nicely.",
				"- Mr. GOOGLE",
			],
		},
		{
			id: "in-3",
			from: "Cloacina <cloacina@mudmothergutters.org>",
			to: "you@trashmail.biz",
			subject: "RE: Your Sewer Pipe Warranty",
			date: "07/29/2026 11:58 PM",
			body: [
				"Mortal,",
				"Your pipes have been cleansed as requested. The extended warranty is eternal, as am I.",
				"Do not flush what should be composted.",
				"Recycle yourself. Give unto me the rest of your filth",
				"- Cloacina, Ruler of the Sewers",
			],
		},
		{
			id: "in-5",
			from: "godintrash@proton.me",
			to: "you@trashmail.biz",
			subject: "Trash Godz E-Zine 001",
			date: "07/07/2026 12:00 PM",
			htmlSrc: "/ezine/the-filth-review-01.html",
		}
	],
	spam: [
		{
			id: "sp-1",
			from: "Landfill Fortune <claim-now@trash-riches.biz>",
			to: "you@trashmail.biz",
			subject: "YOU HAVE WON 10,000 LBS OF PRIME LANDFILL!!!",
			date: "08/01/2026 3:22 AM",
			body: [
				"CONGRATULATIONS!!!",
				"A distant relative you have never heard of has left you 10,000 LBS of prime landfill trash.",
				"To claim your inheritance, simply reply with your bank account number, your mother's maiden name, and a self-addressed stamped envelope.",
				"ACT NOW. THIS OFFER EXPIRES IN 24 HOURS.",
			],
		},
		{
			id: "sp-2",
			from: "Curbside Singles <matches@curbsidesingles.net>",
			to: "you@trashmail.biz",
			subject: "HOT SINGLES in your area... looking thru your trash",
			date: "07/30/2026 6:15 PM",
			body: [
				"Someone in your zip code has been going through your recycling and LIKES what they see.",
				"Click here to see who's interested in your bottle deposits!!",
				"MEMBERSHIP IS FREE (for the first 3 days).",
			],
		},
		{
			id: "sp-4",
			from: "Wanda Compostwell <w.compostwell99@freemail.biz>",
			to: "undisclosed-recipients:",
			subject: "RE: RE: RE: FWD: Make Money Fast From Home (Recycling Cans)",
			date: "07/22/2026 8:47 AM",
			body: [
				"I was skeptical too, but after crushing just 12 cans a day I am now making $4,000/week!!",
				"Forward this message to 10 friends to unlock the SECRET can-crushing method the aluminum industry doesn't want you to know.",
				"God bless,",
				"Wanda",
			],
		},
	],
	sent: [
		{
			id: "se-1",
			from: "you@trashmail.biz",
			to: "recycles@deuspurgamentum.org",
			subject: "RE: Your Weekly Blessing of Refuse",
			date: "08/02/2026 8:02 AM",
			body: [
				"did you get my ssn? I sent it last week haven't heard back from you.",
				"can you respond asap? I need to make sure Jimmy didn't get it that guys a wool fox"
			],
		},
		{
			id: "se-3",
			from: "you@trashmail.biz",
			to: "it-support@trashovision.biz",
			subject: "my mouse isn't working",
			date: "07/20/2026 10:11 AM",
			body: [
				"the little red light on the bottom won't turn on",
				"i already tried unplugging it and plugging it back in",
				"it's still playing bethoven's 9th and it keeps getting louder",
				"please advise",
			],
		},
	],
	trash: [
		{
			id: "tr-2",
			from: "you@trashmail.biz",
			to: "Jordy@trashovision.biz",
			subject: "(draft) about the breakup of the band",
			date: "06/09/2026 11:52 PM",
			body: [
				"look i know things got weird after the dumpster incident but",
			],
		}
	],
}
